import React, { FC } from 'react';
import { Box, Dialog, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { AuthSteps } from 'components/modals/AuthModal/Modal';
import { FormProvider } from 'react-hook-form';
import { Step } from 'components/modals/AuthModal';

interface ModalProps {
  step: Step;
  methods: any;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  nextStep: () => void;
  prevStep: () => void;
}

const Modal: FC<ModalProps> = ({
  step,
  methods,
  isOpen,
  onClose,
  onSubmit,
  nextStep,
  prevStep,
}) => {
  return (
    <Dialog
      sx={{
        '.MuiDialog-paper': {
          borderRadius: '30px',
          padding: '32px',
          width: '540px',
          minHeight: '432px',
          overflowY: 'inherit',
        },
      }}
      open={isOpen}
      onClose={onClose}
    >
      <IconButton
        sx={{ position: 'absolute', top: '-10px', right: '-65px' }}
        onClick={onClose}
        size="large"
        aria-label="close-btn"
      >
        <CloseIcon sx={{ color: 'common.white' }} fontSize="large" />
      </IconButton>

      <Box component={FormProvider} {...methods}>
        <Box
          sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}
          component="form"
          onSubmit={methods.handleSubmit(onSubmit)}
        >
          <AuthSteps
            step={step}
            onClose={onClose}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        </Box>
      </Box>
    </Dialog>
  );
};

export default Modal;
